export const DEMO_ROLE_OPTIONS = [
  "Professor",
  "Associate Professor",
  "Lecturer",
  "Clinical Tutor",
  "Course Coordinator",
  "Other",
];

export const DEMO_TEACHING_AREA_OPTIONS = [
  "Histology",
  "Pathology",
  "Anatomy",
  "Physiology",
  "Medical Sciences",
  "Other",
];

export const DEMO_CLASS_SIZE_OPTIONS = ["<50", "50–150", "150–300", "300+"];

export const DEMO_MAIN_INTEREST_OPTIONS = [
  "Interactive slides",
  "Quiz & assessments",
  "Student engagement tracking",
  "Ready-made content",
  "Custom content creation",
  "Exam prep tools",
];

export const DEMO_MAIN_GOAL_OPTIONS = [
  "Save preparation time",
  "Improve engagement",
  "Better exam results",
  "Standardize teaching",
  "Hybrid/remote teaching",
];

export const DEMO_TIME_OPTIONS = [
  { value: "morning", label: "Morning", hint: "9am–12pm" },
  { value: "midday", label: "Midday", hint: "12pm–3pm" },
  { value: "afternoon", label: "Afternoon", hint: "3pm–6pm" },
  { value: "flexible", label: "Flexible", hint: "" },
];

export const DEMO_PILOT_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "maybe", label: "Maybe" },
  { value: "not_now", label: "Not now" },
];

export const TOTAL_DEMO_STEPS = 9;
